module.exports = __webpack_public_path__ + "img/screen6.22e365eb.png";